import MessagesApp from "../MessagesApp";
export default function BuyerMessages() { return <MessagesApp role="buyer" />; }
